import {ChildParentTenantDto, TenantDto} from "../../model/TenantDto";
import {Alert, Button, Col, Form, FormControl, FormGroup, FormLabel, FormSelect, Row, Spinner} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import {useSaveTenant} from "../../api/tenants/useSaveTenant";
import {useNavigate, useParams} from "react-router-dom";
import {useGetTenant} from "../../api/tenants/useTenant";
import {Field, Formik} from "formik";
import * as Yup from "yup";
import {Loading} from "../../components/Loading";
import NumberFormControl from "../../components/form/NumberFormControl";
import notifier from "simple-react-notifications2";
import {useGetTenants} from "../../api/tenants/useTenants";
import {useGetRoles} from "../../api/users/useRoles";
import TenantBooleanRadioFormGroup from "../../components/tenant/TenantBooleanRadioFormGroup";
import TenantCatalogAssignments from "../../components/catalog/TenantCatalogAssignments";
import CheckboxMultiSelect from "../../components/form/CheckboxMultiSelect";


export default function TenantsEditRoute() {
    const {tenantId} = useParams();
    return <TenantsEdit key={tenantId} tenantId={tenantId}/>;
}

function TenantsEdit({tenantId}: {tenantId?: string}) {
    const navigate = useNavigate();

    const {loading, data, error, execute} = useGetTenant();
    const {loading: loadingAll, data: dataAll, error:errorAll, execute:executeAll} = useGetTenants();
    const {loading: loadingRoles, data: dataRoles, error: errorRoles, execute: executeRoles} = useGetRoles();

    const {loading: loadingSave, data: dataSave, error: errorSave, execute: executeSave} = useSaveTenant();
    const [showModal, setShowModal] = useState(false);
    const [parent, setParent] = useState<ChildParentTenantDto>()
    const [catalogAssignmentPending, setCatalogAssignmentPending] = useState(false);


    useEffect(() => {
        executeGet();
    }, [tenantId]);

    function executeGet() {
        executeAll();
        if (tenantId && !Number.isNaN(tenantId)) {
            execute(Number.parseInt(tenantId));
            executeRoles(Number.parseInt(tenantId));
        }
    }

    if(!data) return (<Loading/>);

    const emailListSchema = Yup.string().required().test({
        name: 'emails',
        message: 'Invalid email format',
        test: function(value: string | undefined) {
            if (!value) return false;

            const emails = value.split(';').map(email => email.trim())
                .filter(email => email.length > 0);

            if (emails.length === 0) {
                return this.createError({ message: 'At least one valid email is required' });
            }

            const emailSchema = Yup.string().email();
            const invalidEmails = emails.filter(email => {
                try {
                    emailSchema.validateSync(email);
                    return false;
                } catch {
                    return true;
                }
            });

            if (invalidEmails.length > 0) {
                return this.createError({
                    message: `Invalid email(s): ${invalidEmails.join(', ')}`
                });
            }

            return true;
        }
    });
    const schema = Yup.object().shape({
        title: Yup.string().required('Title is required'),
        employerSubsidyPercent: Yup.number().nullable(),
        employerSubsidyMonthlyEuros: Yup.number().nullable(),
        employerRetentionPercent: Yup.number().nullable(),
        employerRetentionMonthlyEuros: Yup.number().nullable(),
        employerSubsidyThresholdType: Yup.string().oneOf(["NONE", "INCOME_ASSESSMENT_CEILING"]).required(),
        signupCode: Yup.string().nullable(),
        contractInfo: Yup.string().nullable(),
        workplaceAddress: Yup.string().nullable(),
        parent: Yup.object<ChildParentTenantDto>().nullable(),
        registerEmail: emailListSchema,
        orderEmail: emailListSchema,
    });

    function save(dto: TenantDto) {
        executeSave(dto).then(res => {
            notifier.success("Saved")
            executeGet()
        }).catch(() => undefined);
    }
    function getTenantById(id: number): ChildParentTenantDto {
        return dataAll!!.find((t: TenantDto) => t.id === id)!!
    }
    function handleParentChange(event: React.ChangeEvent<HTMLSelectElement>): ChildParentTenantDto | undefined {
        const id = Number.parseInt(event.target.value);
        if (!Number.isNaN(id)) {
            return getTenantById(id) as ChildParentTenantDto
            // setParent(getTenantById(id))
        }
        return undefined
    }

    function getAvailableTenants(): TenantDto[] {
        return dataAll.filter(t => t.id !== data?.id)
    }

    function contractConfig() {
        navigate(`/tenants/${tenantId}/contract-config`)
    }
    function userInfoConfig() {
        navigate(`/tenants/${tenantId}/user-info-config`)
    }

    return (
        <>
            <Container>
                <Row>
                    <Col>
                        <Button variant="primary" onClick={contractConfig}>
                            Contract config
                        </Button>
                        <Button variant="primary" onClick={userInfoConfig}>
                            User info config
                        </Button>
                    </Col>

                </Row>
                <Formik initialValues={data} validationSchema={schema} onSubmit={values => save(values)}>
                    {({handleSubmit, setFieldValue, handleChange, handleBlur, values, touched, errors}) => (
                        <Form onSubmit={handleSubmit}>
                            {/*<Row>{JSON.stringify(values)}</Row>*/}
                            <FormGroup>
                                <FormLabel>Title</FormLabel>
                                <Field name="title" value={values.title} as={Form.Control}
                                       isInvalid={touched.title && !!errors.title} onChange={handleChange}/>
                                <FormControl.Feedback type="invalid">{errors.title}</FormControl.Feedback>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>Arbeitgeberzuschuss Prozent</FormLabel>
                                <Field type="number" name="employerSubsidyPercent" value={values.employerSubsidyPercent} as={NumberFormControl}
                                       isInvalid={touched.employerSubsidyPercent && !!errors.employerSubsidyPercent} onChange={handleChange}/>
                                <FormControl.Feedback type="invalid">{errors.employerSubsidyPercent}</FormControl.Feedback>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>Arbeitgeberzuschuss Euro</FormLabel>
                                <Field type="number" name="employerSubsidyMonthlyEuros" value={values.employerSubsidyMonthlyEuros} as={NumberFormControl}
                                       isInvalid={touched.employerSubsidyMonthlyEuros && !!errors.employerSubsidyMonthlyEuros} onChange={handleChange}/>
                                <FormControl.Feedback type="invalid">{errors.employerSubsidyMonthlyEuros}</FormControl.Feedback>
                            </FormGroup>
                            <FormGroup className="mt-3 mb-3">
                                <FormLabel>Arbeitgeberzuschuss-Grenze</FormLabel>
                                <FormSelect name="employerSubsidyThresholdType" value={values.employerSubsidyThresholdType}
                                            isInvalid={touched.employerSubsidyThresholdType && !!errors.employerSubsidyThresholdType} onChange={handleChange}>
                                    <option value="NONE">Kein Limit</option>
                                    <option value="INCOME_ASSESSMENT_CEILING">Beitragsbemessungsgrenze (BBG)</option>
                                </FormSelect>
                                <FormControl.Feedback type="invalid">{errors.employerSubsidyThresholdType}</FormControl.Feedback>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>Arbeitgebereinbehalt Prozent</FormLabel>
                                <Field type="number" name="employerRetentionPercent" value={values.employerRetentionPercent} as={NumberFormControl}
                                       isInvalid={touched.employerRetentionPercent && !!errors.employerRetentionPercent} onChange={handleChange}/>
                                <FormControl.Feedback type="invalid">{errors.employerRetentionPercent}</FormControl.Feedback>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>Arbeitgebereinbehalt Euro</FormLabel>
                                <Field type="number" name="employerRetentionMonthlyEuros" value={values.employerRetentionMonthlyEuros} as={NumberFormControl}
                                       isInvalid={touched.employerRetentionMonthlyEuros && !!errors.employerRetentionMonthlyEuros} onChange={handleChange}/>
                                <FormControl.Feedback type="invalid">{errors.employerRetentionMonthlyEuros}</FormControl.Feedback>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>Signup code</FormLabel>
                                <Field name="signupCode" value={values.signupCode} as={Form.Control}
                                       isInvalid={touched.signupCode && !!errors.signupCode} onChange={handleChange}/>
                                <FormControl.Feedback type="invalid">{errors.signupCode}</FormControl.Feedback>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>Contract Info</FormLabel>
                                <FormControl as="textarea"
                                       style={{
                                           height: '100px', // This can be set based on your design requirements
                                           overflowY: 'auto',
                                           resize: 'vertical' // This allows users to resize the textarea vertically
                                       }}
                                       name="contractInfo" value={values.contractInfo} onChange={handleChange}
                                       isInvalid={touched.contractInfo && !!errors.contractInfo}/>
                                <FormControl.Feedback type="invalid">{errors.contractInfo}</FormControl.Feedback>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>Arbeitsstätte</FormLabel>
                                <FormControl as="textarea"
                                       style={{
                                           height: '100px',
                                           overflowY: 'auto',
                                           resize: 'vertical'
                                       }}
                                       name="workplaceAddress" value={values.workplaceAddress} onChange={handleChange}
                                       isInvalid={touched.workplaceAddress && !!errors.workplaceAddress}/>
                                <Form.Text className="text-muted">
                                    Optional. Erste Tätigkeitsstätte der Mitarbeitenden, falls sie von der Vertragsanschrift (Contract Info) abweicht.
                                    Wird als Ziel für die Berechnung der Pendelstrecke verwendet. Leer lassen, um die Vertragsanschrift zu verwenden.
                                </Form.Text>
                                <FormControl.Feedback type="invalid">{errors.workplaceAddress}</FormControl.Feedback>
                            </FormGroup>

                            <FormGroup className="mb-3">
                                <FormLabel>Parent company</FormLabel>
                                <FormSelect
                                    name="parent"
                                    aria-label="Parent" style={{borderRadius: '50rem'}}
                                    className="form-select-sm"
                                    value={values.parent?.id} onChange={event => {
                                        setFieldValue('parent', handleParentChange(event));
                                    }}>
                                    <option key={-1} value="">Select parent</option>
                                    {getAvailableTenants().map((p, index) => (
                                        <option key={index}
                                                value={p.id}>{p.title}</option>
                                    ))}
                                </FormSelect>
                                <FormControl.Feedback type="invalid">
                                    {errors.parent}
                                </FormControl.Feedback>
                            </FormGroup>

                            <FormGroup>
                                <FormLabel>Register email ';' separated</FormLabel>
                                <Field name="registerEmail" value={values.registerEmail} as={Form.Control}
                                       isInvalid={touched.registerEmail && !!errors.registerEmail} onChange={handleChange}/>
                                <FormControl.Feedback type="invalid">{errors.registerEmail}</FormControl.Feedback>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>Order email ';' separated</FormLabel>
                                <Field name="orderEmail" value={values.orderEmail} as={Form.Control}
                                       isInvalid={touched.orderEmail && !!errors.orderEmail} onChange={handleChange}/>
                                <FormControl.Feedback type="invalid">{errors.orderEmail}</FormControl.Feedback>
                            </FormGroup>
                            <TenantBooleanRadioFormGroup name={"requireConfirmation"} value={values.requireConfirmation} setFieldValue={setFieldValue} touched={touched} errors={errors}/>
                            <TenantBooleanRadioFormGroup name={"isOrderExportEnabled"} value={values.isOrderExportEnabled} setFieldValue={setFieldValue} touched={touched} errors={errors}/>
                            <FormGroup className="mt-3 mb-3">
                                {errorRoles && (
                                    <Alert variant="danger" role="alert">Roles could not be loaded.</Alert>
                                )}
                                {loadingRoles ? (
                                    <p aria-live="polite"><Spinner animation="border" size="sm" className="me-2" />Loading roles...</p>
                                ) : (
                                    <CheckboxMultiSelect
                                        idPrefix="tenant-mfa-role"
                                        legend="MFA required for roles"
                                        options={dataRoles.map(role => ({id: role.id, label: role.name}))}
                                        selectedIds={dataRoles.filter(role => values.mfaRequiredRoleNames.includes(role.name)).map(role => role.id)}
                                        onToggle={id => {
                                            const roleName = dataRoles.find(role => role.id === id)!!.name;
                                            setFieldValue('mfaRequiredRoleNames', values.mfaRequiredRoleNames.includes(roleName)
                                                ? values.mfaRequiredRoleNames.filter(name => name !== roleName)
                                                : [...values.mfaRequiredRoleNames, roleName]);
                                        }}
                                        disabled={!!errorRoles}
                                        emptyMessage="No roles are available."
                                    />
                                )}
                            </FormGroup>
                            <TenantBooleanRadioFormGroup name={"useGrossVehiclePrice"} value={values.useGrossVehiclePrice} setFieldValue={setFieldValue} touched={touched} errors={errors}/>
                            <TenantBooleanRadioFormGroup name={"isMonetaryBenefitVatSalaryConversionEnabled"} value={values.isMonetaryBenefitVatSalaryConversionEnabled} setFieldValue={setFieldValue} touched={touched} errors={errors}/>


                            <div className="mt-5 mb-5 d-grid gap-2 col-md-8 col-12 mx-auto">
                                {loadingSave && (<Loading/>)}
                                <Button disabled={loadingSave || catalogAssignmentPending || loadingRoles || !!errorRoles} variant="primary" type="submit">
                                    Submit
                                </Button>
                                {/*<Button variant="primary" onClick={() => handleSubmit()}>*/}
                                {/*    Submit2*/}
                                {/*</Button>*/}
                            </div>
                        </Form>
                    )}
                </Formik>
                <TenantCatalogAssignments
                    key={tenantId}
                    tenantId={Number.parseInt(tenantId!!)}
                    tenantSavePending={loadingSave}
                    onPendingChange={setCatalogAssignmentPending}
                />
            </Container>
        </>
    )
}
